var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTicket(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 111,
    viewBox: "0 0 111 111",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_703_256583)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_703_256583",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 111,
    height: 111
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.890625 0.242508H110.89V110.242H0.890625V0.242508Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_703_256583)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.0656 27.6071C40.0656 34.9412 34.12 40.8867 26.7859 40.8867C19.4518 40.8867 13.5062 34.9412 13.5062 27.6071C13.5062 20.273 19.4518 14.3274 26.7859 14.3274C34.12 14.3274 40.0656 20.273 40.0656 27.6071Z",
    fill: "#FF7591"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2406 14.4084C27.4942 16.9978 27.1163 19.6795 27.118 22.3743C27.118 23.5721 27.1928 24.7526 27.3357 25.9124C22.5655 27.4165 18.329 30.1332 14.9867 33.6979C17.1949 37.967 21.6479 40.8867 26.7859 40.8867C34.12 40.8867 40.0655 34.9414 40.0655 27.607C40.0655 20.7647 34.89 15.1333 28.2406 14.4084Z",
    fill: "#FD5C70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.0232 22.3751C78.0232 34.5986 68.114 44.5078 55.8905 44.5078C43.667 44.5078 33.7578 34.5986 33.7578 22.3751C33.7578 10.1516 43.667 0.242401 55.8905 0.242401C68.114 0.242401 78.0232 10.1516 78.0232 22.3751Z",
    fill: "#FFFDDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.8098 24.5884C68.086 24.5884 61.064 27.6484 55.8904 32.6188C50.7168 27.6484 43.6946 24.5884 35.9708 24.5884C35.2661 24.5884 34.5672 24.6151 33.875 24.6651C35.021 35.8127 44.4401 44.5078 55.8904 44.5078C67.3407 44.5078 76.7598 35.8127 77.9058 24.6651C77.2083 24.6143 76.5092 24.5888 75.8098 24.5884Z",
    fill: "#FFF3AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.9695 85.7595L58.7902 82.3717C56.5317 81.436 55.459 78.8467 56.3947 76.5881L86.8861 2.9753C87.8215 0.716652 90.411 -0.355843 92.6696 0.579582L100.849 3.96767C103.107 4.90309 104.18 7.49259 103.244 9.75124L72.753 83.3638C71.8174 85.6224 69.2281 86.6952 66.9695 85.7595Z",
    fill: "#FFD3A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.574 79.9781L95.0654 6.36536C96.001 4.10672 98.5903 3.03423 100.849 3.96986L92.6697 0.581787C90.411 -0.353638 87.8217 0.718857 86.8861 2.97751L56.3947 76.5903C55.4593 78.8489 56.5318 81.4382 58.7904 82.3739L66.9697 85.7617C64.7111 84.8261 63.6383 82.2368 64.574 79.9781Z",
    fill: "#FFBE74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.8041 15.2446L98.1625 22.0205L91.3866 38.3789L75.0282 31.603L81.8041 15.2446Z",
    fill: "#E7886E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.9835 18.6338L81.8042 15.246L75.0284 31.6043L83.2075 34.9922L89.9835 18.6338Z",
    fill: "#DC6646"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.9425 53.3595C97.9425 65.583 88.0333 75.4922 75.8098 75.4922C63.5863 75.4922 53.6771 65.583 53.6771 53.3595C53.6771 41.136 63.5863 31.2268 75.8098 31.2268C88.0333 31.2268 97.9425 41.136 97.9425 53.3595Z",
    fill: "#FFCCD3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.6771 53.3609C53.6771 59.4554 56.1407 64.974 60.1261 68.9766C63.0456 64.4762 64.7435 59.1133 64.7435 53.3609C64.7435 47.6085 63.0456 42.2456 60.1261 37.7452C56.1407 41.7476 53.6771 47.2665 53.6771 53.3609Z",
    fill: "#FFABB9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.1038 53.3595C58.1038 65.583 48.1946 75.4922 35.9711 75.4922C23.7476 75.4922 13.8384 65.583 13.8384 53.3595C13.8384 41.136 23.7476 31.2268 35.9711 31.2268C48.1946 31.2268 58.1038 41.136 58.1038 53.3595Z",
    fill: "#BE9EDF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9443 53.3595C24.9443 43.0537 31.9881 34.3933 41.5239 31.9293C39.7101 31.4615 37.8443 31.2254 35.9711 31.2268C23.7474 31.2268 13.8384 41.136 13.8384 53.3595C13.8384 65.583 23.7474 75.4922 35.9711 75.4922C37.8888 75.4922 39.7495 75.2481 41.5239 74.7897C31.9881 72.3256 24.9443 63.6653 24.9443 53.3595Z",
    fill: "#938ED9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5082 87.3696L18.1967 101.484C19.1646 106.566 23.6075 110.242 28.7805 110.242H82.5236C87.6965 110.242 92.1395 106.566 93.1074 101.484L95.7959 87.3696L55.8905 80.7298L15.5082 87.3696Z",
    fill: "#84DFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6654 101.484L36.3282 83.9634L15.5082 87.3696L18.1965 101.484C19.1646 106.566 23.6075 110.242 28.7805 110.242H50.2494C45.0762 110.242 40.6332 106.566 39.6654 101.484Z",
    fill: "#2FCFFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.292 63.7615H11.0117L15.508 87.3676C22.6766 88.7596 24.0299 93.6406 33.5183 93.6406C44.5844 93.6406 44.5844 87.0009 55.6505 87.0009C66.7173 87.0009 66.7173 93.6406 77.7839 93.6406C87.2731 93.6406 88.6264 88.7594 95.7957 87.3676L100.292 63.7615Z",
    fill: "#FBF081"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0118 63.7615L15.5083 87.3676C22.6767 88.7596 24.03 93.6406 33.5184 93.6406C35.2956 93.6406 36.7864 93.4688 38.0844 93.1813L32.4807 63.7615H11.0118Z",
    fill: "#FAD271"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.890625 63.7648C0.890625 61.3201 2.87255 59.3382 5.31725 59.3382H106.464C108.908 59.3382 110.89 61.3201 110.89 63.7648C110.89 66.2095 108.908 68.1914 106.464 68.1914H5.31725C2.87255 68.1914 0.890625 66.2095 0.890625 63.7648Z",
    fill: "#84DFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0311 57.1219V81.4679C26.0311 83.9126 28.0131 85.8945 30.4578 85.8945C32.9025 85.8945 34.8842 83.9126 34.8842 81.4679V72.6149C34.8842 70.1702 36.8661 68.1882 39.3108 68.1882C41.7555 68.1882 43.7372 70.1702 43.7372 72.6149C43.7372 75.0596 45.7191 77.0413 48.1638 77.0413C50.6085 77.0413 52.5905 75.0596 52.5905 72.6149V57.1219H26.0311Z",
    fill: "#BE9EDF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3595 63.7648C22.3595 61.3201 24.3414 59.3382 26.7861 59.3382H5.31725C2.87255 59.3382 0.890625 61.3201 0.890625 63.7648C0.890625 66.2095 2.87255 68.1914 5.31725 68.1914H26.7861C24.3414 68.1914 22.3595 66.2095 22.3595 63.7648Z",
    fill: "#2FCFFC"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_703_256583"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 110,
    height: 110,
    fill: "white",
    transform: "translate(0.890625 0.242188)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicket);
export default __webpack_public_path__ + "static/media/ticket.91518c7024aa6048a971276b26a01181.svg";
export { ForwardRef as ReactComponent };